import React from "react";
import { View } from "react-native";
import { getTranslation } from "../../helpers/getTranslation";
import { useSelector } from "react-redux";
import PtFileUploader from "../pt-file-uploader/pt-file-uploader";
import { PtCustomerUploadProps } from './pt-customer-upload-props';

const getLabels = (props: any) => {
  return {
    title: props.title || getTranslation('file.upload.title.customers') || 'Upload your customers',
    successMessage: props.title || getTranslation('file.upload.success.message.customers') || 'Customer(s) upload success',
    pickerButtonLabel: props.title || getTranslation('file.upload.picker.customers.label') || 'Upload your file here to create or update customers',
  }
};


export default function PtCustomerUpload(props: PtCustomerUploadProps) {

  const customerData: any = useSelector((state: any) => state.customerDataReducer);
  const labels = getLabels(props);

  if (customerData.isDistributor || customerData.isPortalMaster) {
    return (
      <View>
        <PtFileUploader
          title={labels.title}
          explanationText={props.explanationText}
          uploadType={'customers'}
          fileType={'text/xml'}
          pickerButtonLabel={labels.pickerButtonLabel}
          pickerButtonIcon={'document-xml'}
          successMessage={labels.successMessage}
        />
      </View>
    )
  }
  else {
    return (null)
  }
}
